module.exports = __webpack_public_path__ + "media/images/mailer/thumb_584-48b240a8c0c9758edc1cafabe8fdf4cb.jpg";